import {Component, OnInit} from '@angular/core';
import {PageAction} from '../../../components/page-actions/page-actions.component';
import {ActivatedRoute, Router} from '@angular/router';
import {TranslationService} from '@services/translation/translation.service';
import { Models } from '@ibexfusion/models';

@Component({
    selector: 'app-translation-detail',
    templateUrl: './translation-detail.component.html',
    styleUrls: ['./translation-detail.component.scss'],
    providers: [TranslationService],
    standalone: false
})

export class TranslationDetailComponent implements OnInit {
  public pageActions: PageAction[];
  public translation: Models.Translation;
  public isLoading = false;
  public title = 'Translation';
  translationId: string;


  constructor(public translationService: TranslationService, private activatedRoute: ActivatedRoute, private router: Router) {
  }

  ngOnInit() {
    this.createPageActions();
    if (this.activatedRoute.snapshot.params['id']) {
      this.isLoading = true;
      this.translationId = this.activatedRoute.snapshot.params['id'];
      this.translationService.get(this.translationId).then(result => {
        result.data = JSON.parse(result.data);
        this.translation = result;
        this.isLoading = false;
      });
    }
  }

  private createPageActions(): void {
    this.pageActions = [
      new PageAction({
        icon: 'subdirectory_arrow_left',
        title: 'Go to Overview',
        callback: () => {
          this.router.navigate(['translation']);
        }
      }),
      new PageAction({
        icon: 'edit',
        title: 'Edit Pipe',
        callback: () => {
          this.router.navigate(['translation', this.translationId, 'edit']);
        }
      })
    ];
  }
}
